import { memo } from "react";
import { formatCurrencyToLocale } from "../../../../utils/method";
import "./invoice-list-amount-cells.scss";

const formatAmountCell = (value) => formatCurrencyToLocale(value ?? 0);

/** Single numeric amount column (invoice net / verified net) */
export const SingleInvoiceAmountCell = memo(({ value }) => (
	<div className="pit-amount-cell">
		<span className="pit-amount-cell__value">{formatAmountCell(value)}</span>
	</div>
));

SingleInvoiceAmountCell.displayName = "SingleInvoiceAmountCell";

/** Payment net+gross when supplier info has amounts; otherwise em dash */
export const InvoicePaymentAmountCell = memo(({ data, t }) => {
	if (!data?.hasPaymentAmounts) {
		return (
			<div className="text-center text-secondary pit-amount-cell">-</div>
		);
	}

	return (
		<div className="pit-amount-cell pit-amount-cell--stacked">
			<div className="pit-amount-cell__row">
				<span className="pit-amount-cell__label">{t("invoice.net")}</span>
				<span className="pit-amount-cell__value">
					{formatAmountCell(data.paymentAmountNet)}
				</span>
			</div>
			<div className="pit-amount-cell__row">
				<span className="pit-amount-cell__label">{t("invoice.gross")}</span>
				<span className="pit-amount-cell__value">
					{formatAmountCell(data.paymentAmountGross)}
				</span>
			</div>
		</div>
	);
});

InvoicePaymentAmountCell.displayName = "InvoicePaymentAmountCell";
